/* Daten der Player Card, die nicht direkt im Spielerobjekt stehen — reine Funktionen, kein DOM.
 *
 *  - Schlagwörter (traits): höchstens drei, je höchstens 20 Zeichen, getrimmt, leere weg.
 *  - Trikotnummer: wird nicht erfasst, sondern aus den Matches abgeleitet (häufigste shirtNumber).
 *  - Saison: aus dem heutigen Datum (Saison beginnt am 1. Juli), wird nicht gespeichert.
 *  - Fehlendes: was auf der Karte noch fehlen würde (nur Hinweis in der Oberfläche, nie ein Fehler).
 */

export const TRAITS_MAX = 3;
export const TRAIT_LENGTH = 20;

const clean = (v) => (v == null ? '' : String(v).replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s+/g, ' ').trim());

/**
 * Schlagwörter bereinigen: getrimmt, Leerraum zusammengezogen, auf TRAIT_LENGTH gekürzt, leere und doppelte
 * (ohne Beachtung der Groß-/Kleinschreibung) weg, höchstens TRAITS_MAX. Kein Array = leere Liste.
 */
export function cleanTraits(list) {
  if (!Array.isArray(list)) return [];
  const out = [];
  const seen = new Set();
  for (const item of list) {
    const t = clean(item).slice(0, TRAIT_LENGTH).trim();
    if (!t || seen.has(t.toLowerCase())) continue;
    seen.add(t.toLowerCase());
    out.push(t);
    if (out.length >= TRAITS_MAX) break;
  }
  return out;
}

/**
 * Häufigste Trikotnummer über die Matches. Gleichstand: die Nummer, die zuerst vorkommt. Keine Nummer: ''.
 * Es zählen nur Nummern aus 1–3 Ziffern (führendes # und Nullen werden entfernt).
 */
export function deriveShirtNumber(videos) {
  const counts = new Map();
  const order = [];
  for (const v of Array.isArray(videos) ? videos : []) {
    if (!v || typeof v !== 'object') continue;
    const m = /^#?\s*0*(\d{1,3})$/.exec(clean(v.shirtNumber));
    if (!m) continue;
    const n = m[1];
    if (!counts.has(n)) order.push(n);
    counts.set(n, (counts.get(n) || 0) + 1);
  }
  let best = '';
  let bestCount = 0;
  for (const n of order) {
    if (counts.get(n) > bestCount) {
      best = n;
      bestCount = counts.get(n);
    }
  }
  return best;
}

/** Saison als "2026 / 2027": ab 1. Juli die neue. Lokales Datum, nichts wird gespeichert. */
export function seasonLabel(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const start = d.getMonth() >= 6 ? y : y - 1; // Monat 6 = Juli
  return `${start} / ${start + 1}`;
}

/**
 * Was der Karte noch fehlt (Schlüssel für Hinweise in der Oberfläche). Nur Hinweise, nie ein Fehler.
 * @returns {Array<'photo'|'highlight'|'matches'|'traits'>}
 */
export function cardGaps(player) {
  const p = player || {};
  const gaps = [];
  if (!p.avatarPath && !p.bioPhotoPath && !p.avatar) gaps.push('photo');
  const hv = p.highlightVideo;
  if (!(hv && typeof hv === 'object' && (clean(hv.url) || clean(hv.title)))) gaps.push('highlight');
  if (!(Array.isArray(p.videos) && p.videos.some((v) => v && (clean(v.title) || clean(v.url))))) gaps.push('matches');
  if (!cleanTraits(p.traits).length) gaps.push('traits');
  return gaps;
}
